import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import API from '../../common/services/api.config.json';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DownloadableDocument } from 'app/modules/common/entities/dropdown/downloadable-document.model';

@Injectable({
    providedIn: 'root',
})
export class FileExportService {
    public isLoading = false;

    constructor(
        private apiService: ApiService,
        private sharedService: SharedService
    ) {}

    public exportTableToExcel(tableId: string, name?: string): any {
        const { sheetName, fileName } = this.getFileName(name);
        const targetTableElm = document.getElementById(tableId);
        const wb = XLSX.utils.table_to_book(targetTableElm, <
            XLSX.Table2SheetOpts
        >{
            sheet: sheetName,
        });
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    }

    public exportDatasetToExcel(arr: any[], name?: string): any {
        const { sheetName, fileName } = this.getFileName(name);
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(arr);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    }

    private getFileName(name: string): any {
        const timeSpan = new Date().toISOString();
        const sheetName = name || 'ExportResult';
        const fileName = `${sheetName}-${timeSpan}`;
        return {
            sheetName,
            fileName,
        };
    }

    public exportWordDocument(name: string): any {
        this.GetWordDocument('1').subscribe(
            (res) => {
                if (res.code === 0) {
                    const file = res.result.file;
                    const fileName = res.result.fileName;
                    const link = document.createElement('a');
                    link.setAttribute('type', 'hidden');
                    link.href = 'data:application/octet-stream;base64,' + file;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    this.sharedService.ShowSnackBar(res.message, '', 2000);
                }
            },
            (err) => {
                this.sharedService.ShowSnackBar(
                    'No se ha podido descargar el documento',
                    '',
                    2000
                );
                console.error(err);
            }
        );
    }

    private GetWordDocument(trabajadorId: string): Observable<RestResponse> {
        let url = '';
        if (this.sharedService.selectedSelectionTabId === 1) {
            const parameters = `EmpresaID`;
            url = `${API.Selection.getEmployeeSelectionWordDoc}?${parameters}`;
            url = url.replace('{employeeId}', trabajadorId);
        }

        return this.apiService.get(url);
    }

    public DownloadFile(file: any, fileName: string): void {
        const link = document.createElement('a');
        link.setAttribute('type', 'hidden');
        link.href = 'data:application/octet-stream;base64,' + file;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    public DownloadDoc(downloadableDocument: DownloadableDocument) {
        this.DownloadFile(
            downloadableDocument.file,
            downloadableDocument.fileName
        );
    }
}
